export type ConnectionStatus =
  | 'active'
  | 'testing'
  | 'error'
  | 'disabled'
  | 'pending_install'
  | 'uninstalled';

export type TokenStatus = 'live' | 'missing';

export type DashboardResponse = {
  connection: {
    id: string;
    label: string;
    shop_domain: string;
    status: ConnectionStatus;
    token_status: TokenStatus;
  };
  lastSync: null | {
    entity: 'product' | 'inventory';
    completed_at: string;
    outcome: 'success' | 'failure';
    count: number;
  };
};

export type InstallResponse = { status: 'cached' | 'exchanged' };

/**
 * Discriminated error surface for `POST /api/shopify/install`. The SPA
 * branches on `code` to render distinct UIs:
 *   - 'no_connection_for_shop' — merchant needs to create a Unifd connection
 *   - 'token_exchange_failed'  — Shopify-side failure, offer retry
 *   - 'unknown'                — fallback (network error, 5xx without body)
 */
export type InstallErrorCode =
  | 'no_connection_for_shop'
  | 'token_exchange_failed'
  | 'unknown';

export class InstallError extends Error {
  constructor(public code: InstallErrorCode, public httpStatus: number, message?: string) {
    super(message ?? code);
    this.name = 'InstallError';
  }
}
